<template lang="html">
  <div id="text-page">
    <section class="header-banners-section-s2">
    </section>

    <section class="container main-section" data-aos="fade-in" data-aos-duration="1000">
      <h1 class="mb-2 text-center page-title">Terms and Conditions</h1>

      <div v-html="content"></div>

      <!-- <p>
        <i>Last updated: April 2, 2025</i>
      </p>

      <br />
      <p>
        Welcome to DEC Industries. By accessing and using our website https://decindustries.us and our cloud platform, you agree to be bound by the following Terms and Conditions. If you do not agree with these terms, we recommend that you do not use our services.
      </p>

      <br />
      <h6>1. Identity of the Holder</h6>
      <p>
        DEC Industries is a company dedicated to the sale of health products through a multi-level distribution scheme. We offer a digital platform for customers, distributors, and promoters, facilitating product purchases and growth within the business model.
      </p>

      <br />
      <h6>2. Access and Registration</h6>
      <p>
        To use DEC Industries services, you must register and create a user account. You declare that all information provided is truthful, current, and complete. DEC Industries reserves the right to suspend or cancel accounts that fail to meet this requirement.
      </p>

      <br />
      <h6>3. Use of the Platform</h6>
      <p>
        Users agree to use the site and its tools in a lawful and respectful manner. The following is prohibited:
      </p>
      <ul>
        <li>
          Using the platform for fraudulent, deceptive, or illegal purposes
        </li>
        <li>
          Engaging in practices that affect the system's operation
        </li>
        <li>
          Impersonating another user's identity
        </li>
        <li>
          Distributing offensive or unauthorized content
        </li>
      </ul>

      <br />
      <h6>4. Multi-Level Scheme</h6>
      <p>
        By registering as a distributor, the user agrees to participate in a commission scheme based on their sales volume and that of their referrals. The compensation plan conditions are available within the platform and may be modified with prior notice.
      </p>

      <br />
      <p>
        DEC Industries does not guarantee minimum income, and results depend on each distributor's individual effort.
      </p>

      <br />
      <h6>5. Purchases and Payments</h6>
      <p>
        Purchases made through our store are subject to availability and payment confirmation. Prices are displayed in local currency and include taxes unless otherwise indicated. Accepted payment methods are those visible in the site's checkout.
      </p>

      <br />
      <h6>6. Shipping and Delivery</h6>
      <p>
        Delivery times and shipping conditions may vary depending on the buyer's location. DEC Industries is not responsible for delays attributable to third parties (shipping companies or logistics operators).
      </p>

      <br />
      <h6>7. Returns and Refunds</h6>
      <p>
        Returns will only be accepted for unused products in their original packaging within the first 7 calendar days after delivery. Shipping costs are not refundable, except in cases of defective products or shipping errors.
      </p>

      <br />
      <h6>8. Intellectual Property</h6>
      <p>
        All content present on the platform, including trademarks, logos, texts, images, and source code, is the property of DEC Industries or is licensed for use. Total or partial reproduction without express authorization is prohibited.
      </p>

      <br />
      <h6>9. Modifications</h6>
      <p>
        DEC Industries reserves the right to modify these Terms and Conditions at any time. Changes will take effect upon their publication at https://decindustries.us. Continued use of the site implies acceptance.
      </p>

      <br />
      <h6>10. Limitation of Liability</h6>
      <p>
        DEC Industries shall not be liable for direct or indirect damages arising from the use or misuse of the platform, or for service interruptions due to technical causes, maintenance, or force majeure.
      </p>

      <br />
      <h6>11. Jurisdiction and Applicable Law</h6>
      <p>
        This agreement is governed by Mexican law. In case of dispute, both parties submit to the jurisdiction of the competent courts in Mexico City, waiving any other jurisdiction that might otherwise apply.
      </p>

      <br />
      <h6>12. Contact</h6>
      <p>
        For any questions related to these Terms and Conditions, you may contact us at:<br />
        <strong>contacto@decindustries.us</strong>
      </p> -->
    </section>
  </div>
</template>

<script>
export default {
  data(){
    return{
      content: '',
    }
  },

  methods: {
    getContent: function(){
      axios.get(tools.url('/api/terminos')).then((response)=>{
        this.content = response.data;;
      }).catch((error)=>{
        console.log(error);
      })
    }
  },

  beforeMount(){
    this.getContent();
  }
}
</script>
